export const validateUsername = (username: string) => {
  return username.match(
    /(?!^[@\.\_\-\d])(?!.*[@\.\_\-]$)(?!.*[@\.\_\-]{2,})^([a-zA-Z0-9\-\_\.]{2,64})+$/gm
  );
};
